<div class="panel panel-primary animated fadeIn">
  <div class="panel-body">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card mx-4">
          <div class="card-body p-4">
            <h2>Alterar Password</h2>
            <p></p>
            <form novalidate>
              <div class="input-group mb-3">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
                <input type="password" class="form-control" style="font-size: 14px;" name="oldPassword" autofocus placeholder="Password Atual"
                  [(ngModel)]="model.oldPassword">
              </div>

              <div class="input-group mb-3">
                <span class="input-group-addon">
                  <i class="icon-lock"></i>
                </span>
                <input type="password" class="form-control" name="newPassword" style="font-size: 14px;" 
                  placeholder="Nova Password (min 9 caracteres)" [(ngModel)]="model.newPassword">
              </div>

              <div class="input-group mb-4">
                <span class="input-group-addon">
                  <i class="icon-lock"></i>
                </span>
                <input type="password" class="form-control" name="newPassword2" style="font-size: 14px;" placeholder="Repetir Password"
                  [(ngModel)]="model.newPassword2">
              </div>

              <!-- <div class="input-group error" style="padding-bottom: 10px;">
                {{errorMessage}}
              </div> -->

              <button type="submit" class="btn btn-block btn-success" [ladda]='isSaving'
                (click)="mudarPassword()">Confirmar</button>
            </form>
          </div>
        </div>

        <br />
        <div *ngFor="let alert of alerts">
          <alert [type]="alert.type" [dismissible]="true" [dismissOnTimeout]="alert.timeout"
            (onClosed)="onClosed(alert)">{{ alert.msg }}
          </alert>
        </div>
      </div>
    </div>
  </div>
</div>
